import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import Toast from "./components/Toast";
// import { IntercomProvider } from "react-use-intercom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./config/authConfig";
// import Notification from "./firebaseNotifications/Notification";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const msalInstance = new PublicClientApplication(msalConfig);

if (window.location.hash !== "") {
  console.log("hash found" + window.location.hash);
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <Toast />
        {/* <IntercomProvider
          apiBase="https://api-iam.eu.intercom.io"
          appId={process.env.REACT_APP_INTERCOM_APP_ID}
        > */}
          <App />
        {/* </IntercomProvider> */}
      </MsalProvider>
    </BrowserRouter>
  );
}

// serviceWorkerRegistration.register();
